import { IAddressee } from "./interfaces";

export const initialState: IAddressee.Addressee = {
  IDUSUARIO: 1,
  NMUSUARIO: "",
  CPF: "",
  TELEFONE: "",
  EMAIL: "",
  TOKEN: "",
  OBS: "",
  NICKNAME: "",
  FLCADEIRANTE: 0,
  ISCADEIRANTE: false,
  SENHA: "",
  SYSTEMOP: "",
  VERSIONOP: "",
  STUSUARIO: 0,
  DTUPDATE: "",
  ENDECOMPL: "",
  GRUPOUSUARIO: [
    {
      FLUSERADM: 1,
      ENDERECO: [
        {
          IDMCM: 0,
          BAIRRO: "VILA BERTIOGA",
          CEP: "",
          COMPLEMENTO: "",
          LOGRADOURO: "",
          NUMERO: "0",
          DSCIDADE: "",
          DSUF: "",
          DSMCM: "",
          STMCM: 0,
          ENDECOMPL: [
            {
              VLCOMPLEMENTO: "",
              DSCOMPLEMENTO: "",
            },
          ],
        },
      ],
    },
  ],
};
